.root {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-self: stretch;
}

.label {
  padding: 0 0 4px;
}

.rows {
  display: flex;
  flex-direction: column;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid var(--dark-4);
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &.disabled {
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  }
}
